function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    width: 32,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Error_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    id: "BG",
    r: 16,
    style: {
      fill: "#D72828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z",
    id: "Exclamatory_x5F_Sign",
    style: {
      fill: "#E6E6E6"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f0af6c6f720c0346108499eb623fec3d.svg";
export { ForwardRef as ReactComponent };